import config from '../config';

class LeagueMembershipApi {
  constructor() {
    this.baseUrl = config.API_URL;
  }

  async getTeamSlots(leagueId) {
    const response = await fetch(`${this.baseUrl}/leagues/${leagueId}/team-slots`, {
      credentials: 'include',
    });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || 'Failed to load team slots');
    }
    return response.json();
  }

  async listMembers(leagueId, currentUser) {
    if (!currentUser?.id) {
      throw new Error('User not authenticated');
    }
    const response = await fetch(
      `${this.baseUrl}/leagues/${leagueId}/members?user_id=${currentUser.id}`,
      { credentials: 'include' }
    );
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || 'Failed to load league members');
    }
    return response.json();
  }

  async transferTeam(leagueId, teamName, { userId, email }, currentUser) {
    if (!currentUser?.id) {
      throw new Error('User not authenticated');
    }
    const body = { team_name: teamName };
    if (userId) body.user_id = userId;
    if (email) body.email = email.trim();

    const response = await fetch(
      `${this.baseUrl}/leagues/${leagueId}/members/transfer?commissioner_id=${currentUser.id}`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(body),
      }
    );
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || 'Failed to transfer team');
    }
    return response.json();
  }

  async removeMember(leagueId, memberUserId, currentUser) {
    if (!currentUser?.id) {
      throw new Error('User not authenticated');
    }
    const response = await fetch(
      `${this.baseUrl}/leagues/${leagueId}/members/${memberUserId}?commissioner_id=${currentUser.id}`,
      { method: 'DELETE', credentials: 'include' }
    );
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || 'Failed to remove member');
    }
    return response.json();
  }

  async leavePublicLeague(leagueId, currentUser) {
    if (!currentUser?.id) {
      throw new Error('User not authenticated');
    }
    const response = await fetch(
      `${this.baseUrl}/leagues/${leagueId}/leave?user_id=${currentUser.id}`,
      { method: 'POST', credentials: 'include' }
    );
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || 'Failed to leave league');
    }
    return response.json();
  }
}

const leagueMembershipApi = new LeagueMembershipApi();
export default leagueMembershipApi;
